// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__Rj6GE","h1":"NotFound_h1__E0Q4S","p":"NotFound_p__Wh76l","a":"NotFound_a__mR2B5"};